import React from "react";
import { Box, Text, Banner } from "@sproutsocial/racine";
import Link from "./Link";

export const MenuBanner = ({ componentName }) => {
  return (
    <Box mb={400}>
      <Banner
        text={
          <Box
            width={1}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text.SmallBodyCopy>
              {`${componentName} is part of the Menu ecosystem. `}
              For use cases that are common across all menu types, such as
              keyboard navigation, accessibility, and menu positioning, see the{" "}
              <Link to="/components/seeds-react-menu">
                Menu package documentation
              </Link>
              .
            </Text.SmallBodyCopy>
          </Box>
        }
      />
    </Box>
  );
};
